import { withParams } from 'vuelidate';

const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.){1,}([a-zA-Z]+)(\/.*)?$/;
const linkedinUrlRegex = /^(https?:\/\/)?([\w]+\.)?linkedin\.com\/in\/\S+$/i;
const youtubeUrlRegex = /^(?:https?:\/\/)?(?:www\.)?youtu(?:\.be\/|be.com\/\S*(?:watch|embed)(?:(?:(?=\/[^&\s?]+(?!\S))\/)|(?:\S*v=|v\/)))([^&\s?]+)$/i;
const phoneRegex = /^\+?[0-9]{10,15}$/;

export const youtubeUrlValidator = withParams({ type: 'youtubeUrl' }, (value) => {
  if (!value) {
    return true;
  }

  return !(!value || !value.match(youtubeUrlRegex));
});

export const phoneValidator = withParams({ type: 'phone' }, (value) => {
  if (!value) {
    return true;
  }

  return !(!value || !value.match(phoneRegex));
});

export const linkedinUrlValidator = withParams({ type: 'linkedinUrl' }, (value) => {
  if (!value) {
    return true;
  }

  return !(!value || !value.match(linkedinUrlRegex));
});

export const urlValidator = withParams({ type: 'url-regex' }, (value) => {
  if (!value) {
    return true;
  }

  value = value.trim();

  return !(!value || !value.match(urlRegex));
});
